module.exports = __webpack_public_path__ + "img/26.c5d01033.jpg";